import { createStore } from "vuex";
import notifications from "./modules/notifications";
import leads from "./modules/leads";
import sellers from "./modules/sellers";

export default createStore({
  modules: {
    notifications,
    leads,
    sellers,
  },
});
